import type { ButtonProps } from "antd";
import { FC } from "react";

import { StyledButton } from "./Styled";

interface Props extends ButtonProps {
    onClick?: () => void;
    children: React.ReactNode;

    margin?: string;
    marginTop?: string;
    marginBottom?: string;
    marginLeft?: string;
    marginRight?: string;
    bgColor?: "success";
}

export const BaseButton: FC<Props> = ({
    onClick,
    children,
    margin,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    bgColor,
    ...rest
}) => {
    return (
        <StyledButton
            onClick={onClick}
            $margin={margin}
            $marginTop={marginTop}
            $marginBottom={marginBottom}
            $marginLeft={marginLeft}
            $marginRight={marginRight}
            $bgColor={bgColor}
            {...rest}
        >
            {children}
        </StyledButton>
    );
};

export default BaseButton;
